import http from '@/utils'
import api from '@/api/apiUrls'

export const contentService = {
  fetchTranslations,
  fetchConcepts,
  fetchSitemap,
  fetchSafetyDocs
}

function fetchTranslations(_path) {
  return http.get(api.TRANSLATIONS.replace('{path}', _path))
}

function fetchConcepts(_path) {
  return http.get(api.DP_CONCEPTS.replace('{path}', _path))
}

function fetchSitemap() {
  return http.get(api.SITEMAP)
}

function fetchSafetyDocs() {
  return http.get(api.SAFETY_DOCS)
}
